import Request from '@/plugins/request';

export function getFreightTemplates(params) {
  return Request.get('freight-templates', { params })
}

export function getFreightTemplatesByCustomerId(params = {}) {
  return Request.get('freight-templates/customer-id', { params })
}


export function createFreightTemplate() {
  return Request.get(`freight-templates/create`)
}

export function storeFreightTemplate(data) {
  return Request.post('freight-templates', data)
}

export function updateFreightTemplate(id, data) {
  return Request.put(`freight-templates/${id}`, data)
}

export function editFreightTemplate(id) {
  return Request.get(`freight-templates/${id}/edit`)
}

export function destroyFreightTemplate(id) {
  return Request.delete(`freight-templates/${id}`)
}
